import { FC } from "react";
import { BuddyTeam } from "@jane/lib/src/api/repositories/buddy-teams-repository";
import { Team } from "@jane/lib/src/api/repositories/teams-repository";
import { useApiCall } from "../../../lib/src/api";
import { config } from "../config";
import { ModalFooter } from "@jane/lib/src/components/layout/ModalProvider";

export const DeleteBuddyTeamFromGroupModal: FC<{ buddy: BuddyTeam; team: Team; reload: () => void }> = (props) => {
  const { buddyTeams: buddyTeamsApi, teams: teamsApi } = useApiCall(config);
  const del = async (buddyTeamId: string, teamId: number) => {
    await buddyTeamsApi.delTeam(buddyTeamId, String(teamId));
    props.reload();
  };
  return (
    <div>
      <div>Je staat op het punt om team {props.team.name} te verwijderen van belgroep. Doorgaan?</div>
      <ModalFooter text={"Verwijderen"} onSubmit={() => del(props.buddy.id, props.team.id)} />
    </div>
  );
};

